import FreelancerAgencyUserTypesEnum from '../Enums/FreelancerAgencyUserTypesEnum';
import dateTimeHelper from '../Helpers/datetimeHelper';

export default class FreelancerUserEditItem {
  constructor() {
    this.FreelancerUserId = '';
    this.CompanyName = '';
    this.FirstName = '';
    this.LastName = '';
    this.Email = '';
    this.PhoneNumber = '';
    this.LastLoginDate = '';
    this.IsFieldworkPartner = false;
    this.UserType = FreelancerAgencyUserTypesEnum.IndependentUser;
    this.PrimaryFreelancerUserId = 0;
    this.OfficeId = 0;
    this.PaymentOfficeId = 0;
    this.ApolloMgrId1 = '';
    this.ApolloMgrId2 = '';
    this.ApolloMgrId1Orgin = '';
    this.ApolloMgrId2Orgin = '';
    this.ApolloMgrId1Status = true;
    this.ApolloMgrId2Status = true;
    this.IsActive = '';
    this.CreatedDate = dateTimeHelper.toYYYYsMMsDD(new Date());
    this.ModifiedDate = dateTimeHelper.toYYYYsMMsDD(new Date());
    this.ContractExpiryDate = dateTimeHelper.toYYYYsMMsDD(new Date());
    this.IsKAM = false;
    this.IsRM = false;
    this.IsDQ = false;
    this.NumberOfFees = 0;
    this.NumberOfLineItems = 0;
    this.NumberOfInvoices = 0;
    this.NumberOfCreatedInvoices = 0;
    this.NumberOfPayableAssignments = 0;
    this.PrimaryFreelancerUserName = '';
    this.CurrencyCode = '';
    this.CurrencyId = '';
    this.PaymentCurrencyId = '';
    this.PaymentMethod = '';
    this.PaymentInformation = '';
    this.PIAlipayAccount = '';
    this.PIAccountHolderName = '';
    this.PIBankName = '';
    this.PIBranchNameOrId = '';
    this.PIBankAddress = '';
    this.PIBankAccountNumber = '';
    this.PIBankAccountType = '';
    this.PISwiftIFSCCode = '';
    this.PIIBANCodeBankAccountNumber = '';
    this.PIPaypalWiseWesternUnionEmail = '';
    this.PIPIX = '';
    this.PICPFRUT = '';
    this.PIWesternUnionAddress = '';
    this.PIPIS = '';
    this.PIPayNow = '';
    this.PIEvaluatorSassieId = '';
    this.PitpEvaluatorId = '';
    this.EvaluatorEmail = '';
    this.EvaluatorName = '';
    this.EvaluatorWarning = '';
    this.EvaluatorNotFound = false;
    this.TimebasedSettlementEnabled = '';
    this.IsEmployee = false;
    this.InvoiceNeeded = true;
    this.PIWiseTransferMethod = '';
    this.PIWiseTargetCurrencyId = '';
    this.PIWiseTargetCurrencyCode = '';
    this.PIBankCode = '';

    this.DqsupervisorUserName = '';
    this.KamsuperVisorUserName = '';
    this.RmsuperVisorUserName = '';
    this.OfficeName = '';
    this.ContractorLocationCountryId = '';
    this.ContractorLocationCountryName = '';
    this.PIBankNameAndCode = '';
    this.PIPanNo = '';
    this.BareContactUserId = '';
    this.FreelancerRoleIds = [];
    this.PayIfSame = false;
    this.Pimxclabe = null;
  }
}
